module.exports = __webpack_public_path__ + "static/2import-12863402b0a765251852ea3f6c969c57.png";